export default function Paper(theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          backgroundImage: 'none',
          border: 'none !important',
          borderWidth: '0 !important',
        },
        elevation0: {
          boxShadow: 'none',
        },
        elevation1: {
          boxShadow: theme.shadows[1],
        },
        elevation2: {
          boxShadow: theme.shadows[2],
        },
        elevation3: {
          boxShadow: theme.shadows[3],
        },
        elevation4: {
          boxShadow: theme.shadows[4],
        },
      },
    },
  };
}

